<template>
  <div class="collect-wrap">
    <!-- 详情视图 -->
    <CaseDetail
      v-if="analyzeDetailData"
      :analyze-data="analyzeDetailData"
      :isFavorited="currentDetailFavorited"
      @back="handleDetailBack"
      @favoriteChange="onDetailFavoriteChange"
    />
    <!-- 文件夹列表页 -->
    <CollectFolderList
      v-else-if="!currentFolder"
      @openFolder="handleOpenFolder"
    />
    <!-- 文件夹详情页 -->
    <CollectFolderDetail
      v-else
      :folder-info="currentFolder"
      @backList="handleBackList"
      @view-detail="handleViewDetail"
    />
  </div>
</template>

<script setup>
import { ref } from "vue";
import { AnalyzeCase } from "../../api/case/case";
import CaseDetail from "../casesearch/CaseDetail.vue";
import CollectFolderList from "./CollectFolderList.vue";
import CollectFolderDetail from "./CollectFolderDetail.vue";

// 当前选中文件夹，控制页面切换
const currentFolder = ref(null);

// 查看详情数据
const analyzeDetailData = ref(null);

// 详情页收藏状态：从收藏列表进入的案例默认已收藏
const currentDetailFavorited = ref(false);

// 打开文件夹详情
const handleOpenFolder = (folderRow) => {
  currentFolder.value = folderRow;
};
// 返回收藏夹列表
const handleBackList = () => {
  currentFolder.value = null;
};

// 点击 fileName 查看详情
const handleViewDetail = async (row) => {
  const caseNumber = row.caseNumber || row.fileName;
  if (!caseNumber) return;
  currentDetailFavorited.value = true;
  try {
    const res = await AnalyzeCase({ caseNumber });
    if (res.isSuccess && res.data) {
      analyzeDetailData.value = res.data;
    }
  } catch (err) {
    console.error("AnalyzeCase 请求失败：", err);
  }
};

// 详情页收藏状态变更
const onDetailFavoriteChange = (favorited) => {
  currentDetailFavorited.value = favorited;
};

// 关闭详情，返回列表
const handleDetailBack = () => {
  analyzeDetailData.value = null;
};
</script>
<style lang="less" scoped>
.collect-wrap {
  padding: 24px 0px 0px;
}
</style>
